import { isEmpty } from 'lodash-es';
import {
  UNIT_TRUST_INVESTMENT_ACCOUNT,
  EQUITY_INVESTMENT_ACCOUNT,
  STRUCTURED_PRODUCTS_ACCOUNT,
  BONDS_ACCOUNT,
  HSBC_CONVENTIONAL_UT_ACCOUNT,
  HSBC_AMANAH_UT_ACCOUNT,
} from 'srcAlias/client/enums/productDescriptionCode';
import {
  UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY,
  EQUITY_INVESTMENT_ACCOUNT_CATEGORY,
  STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY,
  BONDS_ACCOUNT_CATEGORY,
} from 'srcAlias/client/enums/productCategory';
export const checkProductType = (value) => {
  if (isEmpty(value)) {
    return undefined;
  }

  if (
    value ===
    `${UNIT_TRUST_INVESTMENT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`
  ) {
    return {
      productDescription: 'Unit Trust Investment Account',
      productDescriptionForAnalytics: 'unit trusts - 085',
      productType: 'UNIT_TRUST',
      accountType: 'UTA',
      productCode: value,
    };
  }
  if (
    value ===
    `${EQUITY_INVESTMENT_ACCOUNT}_${EQUITY_INVESTMENT_ACCOUNT_CATEGORY}`
  ) {
    return {
      productDescription: 'Equity Investment Account',
      productDescriptionForAnalytics: 'equities - 068',
      productType: 'EQUITIES',
      accountType: 'EA',
      productCode: value,
    };
  }
  if (
    value ===
    `${STRUCTURED_PRODUCTS_ACCOUNT}_${STRUCTURED_PRODUCTS_ACCOUNT_CATEGORY}`
  ) {
    return {
      productDescription: 'Structured Products Account',
      productDescriptionForAnalytics: 'structure product - 090 with 68',
      productType: 'STRUCTURED_PRODUCTS',
      accountType: 'SPA',
      productCode: value,
    };
  }
  if (value === `${BONDS_ACCOUNT}_${BONDS_ACCOUNT_CATEGORY}`) {
    return {
      productDescription: 'Bonds Account',
      productDescriptionForAnalytics: 'bond - 090 without 68',
      productType: 'BONDS',
      accountType: 'BA',
      productCode: value,
    };
  }
  if (
    value ===
    `${HSBC_CONVENTIONAL_UT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`
  ) {
    return {
      productDescription: 'HSBC Bank UT Investment Account',
      productDescriptionForAnalytics: 'MY UT 038',
      productType: 'UNIT_TRUST',
      accountType: 'UT',
      productCode: value,
    };
  }
  if (
    value ===
    `${HSBC_AMANAH_UT_ACCOUNT}_${UNIT_TRUST_INVESTMENT_ACCOUNT_CATEGORY}`
  ) {
    return {
      productDescription: 'HSBC Amanah UT Investment Account',
      productDescriptionForAnalytics: 'AMANAH UT 038',
      productType: 'UNIT_TRUST',
      accountType: 'UT',
      productCode: value,
    };
  }
  return undefined;
};
